import { Model } from '@/models/Model';
import { AttributeOption } from '@/models/AttributeOption';

export class Attribute extends Model
{
  protected $name: string = 'Attribute';
  protected $endpoint: string = '/product-attributes';
  protected $fillable: string[] = ['title', 'type',];

  public title?: string;
  public id!: string;
  public type?: string;
  public value?: AttributeOption;
  public options?: AttributeOption[];

  public updateAttributeOption(attributeId: string, payload: any) {
    const url = `/product-attributes/${attributeId}/put-all`;
    return this.request('put', url, payload);
  }

  public deleteAttributeValue(attributeValueId: string) {
    const url = `/attribute-values/${attributeValueId}`;
    return this.request('delete', url);
  }

  public addAttributeToProducts(payload: any) {
    const url = `/product-variants/attach-attribute`;
    return this.request('post', url , payload);
  }
}

export interface AttributeItem {
  attribute?: Attribute | null;
}
